<template>
  <h3>Travelers</h3>
  <TravelerForm v-model:edit-id="editId" v-model:new-id="newId" :is-wizard="false" @error="$emit('error', $event)" />
  <TravelerList v-model:edit-id="editId" v-model:new-id="newId" :is-wizard="false" @error="$emit('error', $event)" @refresh-organizations="$emit('refreshOrganizations', $event)" />
</template>

<script setup>
import { ref } from "vue";
import TravelerForm from "../components/common/TravelerForm.vue";
import TravelerList from "../components/common/TravelerList.vue";

defineProps(["organizations", "organizationId"]);
defineEmits(["error", "info", "scroll", "refreshOrganizations"]);

const editId = ref(null);
const newId = ref(null);
</script>
